// src/pages/rh/AjouterEmploye.jsx
import React, { useState } from "react";
import { 
    Card, Row, Col, Form, Button, Alert, Spinner, 
    InputGroup, Badge 
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { API_BASE_URL } from "../../constants/api";

const ToastNotification = ({ show, onClose, type, title, message }) => {
    React.useEffect(() => {
        if (show) {
            const timer = setTimeout(() => onClose(), 5000);
            return () => clearTimeout(timer);
        }
    }, [show, onClose]);

    if (!show) return null;

    const toastConfig = {
        success: { bgColor: '#10b981', icon: 'ri-checkbox-circle-fill' },
        error: { bgColor: '#ef4444', icon: 'ri-error-warning-fill' },
        info: { bgColor: '#3b82f6', icon: 'ri-information-fill' },
        warning: { bgColor: '#f59e0b', icon: 'ri-alert-fill' }
    };

    const config = toastConfig[type] || toastConfig.info;

    return (
        <div className="toast-notification-fixed" style={{ position: 'fixed', bottom: '20px', right: '20px', zIndex: 9999 }}>
            <div className="toast-modern" style={{ background: 'white', borderRadius: '16px', boxShadow: '0 20px 40px rgba(0,0,0,0.15)', minWidth: '320px', maxWidth: '400px', overflow: 'hidden', animation: 'slideInRight 0.3s ease-out' }}>
                <div className="toast-header-custom" style={{ background: config.bgColor, padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div className="d-flex align-items-center gap-2">
                        <i className={`${config.icon} text-white`} style={{ fontSize: '1.5rem' }}></i>
                        <strong className="text-white fs-6">{title}</strong>
                    </div>
                    <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'white', cursor: 'pointer' }}>
                        <i className="ri-close-line fs-5"></i>
                    </button>
                </div>
                <div className="toast-body-custom" style={{ padding: '16px 20px' }}>
                    <p className="mb-0" style={{ color: '#1e293b', fontSize: '0.9rem' }}>{message}</p>
                </div>
                <div className="toast-progress" style={{ height: '3px', background: config.bgColor, width: '100%', animation: 'shrink 5s linear forwards' }}></div>
            </div>
        </div>
    );
};

export default function AjouterEmploye() {
    const navigate = useNavigate();
    const [saving, setSaving] = useState(false);
    const [toast, setToast] = useState({ show: false, type: '', title: '', message: '' });
    
    const [employe, setEmploye] = useState({
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        adresse: '',
        date_naissance: '',
        lieu_naissance: '',
        nationalite: 'Gabonaise',
        sexe: 'M',
        situation_matrimoniale: 'Célibataire',
        nombre_enfants: 0,
        poste: '',
        departement: '',
        date_embauche: '',
        type_contrat: 'CDI',
        salaire_base: '',
        photo: null,
        cv: null,
        statut: 'actif'
    });

    const showToast = (type, title, message) => {
        setToast({ show: true, type, title, message });
    };

    const hideToast = () => {
        setToast({ show: false, type: '', title: '', message: '' });
    };

    const getCurrentUser = () => {
        try {
            const userStr = localStorage.getItem("user");
            if (userStr && userStr !== "undefined" && userStr !== "null") {
                return JSON.parse(userStr);
            }
        } catch (error) {
            console.error("Erreur parsing utilisateur:", error);
        }
        return null;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEmploye(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e, field) => {
        const file = e.target.files[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                showToast('error', 'Fichier trop volumineux', 'Le fichier ne doit pas dépasser 5 Mo');
                return;
            }
            
            const reader = new FileReader();
            reader.onloadend = () => {
                setEmploye(prev => ({ ...prev, [field]: reader.result }));
                showToast('success', 'Fichier ajouté', `Le ${field === 'photo' ? 'photo' : 'CV'} a été chargé avec succès`);
            };
            reader.onerror = () => {
                showToast('error', 'Erreur de lecture', 'Impossible de lire le fichier');
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!employe.nom || !employe.prenom || !employe.date_embauche) {
            showToast('error', 'Erreur', 'Veuillez remplir tous les champs obligatoires');
            return;
        }

        setSaving(true);

        try {
            const token = localStorage.getItem("token");
            const currentUser = getCurrentUser();
            
            const dataToSend = {
                ...employe,
                created_by: currentUser?.id_utilisateur || currentUser?.id,
                nombre_enfants: parseInt(employe.nombre_enfants) || 0,
                salaire_base: parseFloat(employe.salaire_base) || 0
            };
            
            const response = await fetch(`${API_BASE_URL}/employes.php`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(dataToSend)
            });

            const result = await response.json();

            if (result.success) {
                showToast('success', 'Succès', `Employé créé avec succès ! Matricule: ${result.matricule}`);
                setTimeout(() => {
                    navigate('/rh/employes');
                }, 2000);
            } else {
                showToast('error', 'Erreur', result.message || "Erreur lors de l'enregistrement");
            }
        } catch (err) {
            showToast('error', 'Erreur', "Erreur de connexion au serveur");
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <Header />
            <div className="main main-app p-3 p-lg-4" style={{ background: '#f8fafc', minHeight: '100vh' }}>
                <div className="container-fluid">
                    
                    <ToastNotification 
                        show={toast.show}
                        onClose={hideToast}
                        type={toast.type}
                        title={toast.title}
                        message={toast.message}
                    />

                    {/* En-tête */}
                    <div className="d-md-flex align-items-center justify-content-between mb-4">
                        <div>
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <div className="p-2 bg-success bg-opacity-10 rounded-3">
                                    <i className="ri-user-add-line fs-20 text-success"></i>
                                </div>
                                <div>
                                    <h4 className="main-title mb-0 fw-bold">Nouvel employé</h4>
                                    <p className="text-muted small mb-0">Ajouter un employé au personnel</p>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex gap-2 mt-3 mt-md-0">
                            <Button 
                                variant="outline-secondary" 
                                onClick={() => navigate('/rh/employes')}
                                className="rounded-pill px-3 d-flex align-items-center gap-1"
                                size="sm"
                            >
                                <i className="ri-arrow-left-line"></i>
                                Retour
                            </Button>
                        </div>
                    </div>

                    <Row className="justify-content-center">
                        <Col lg={10}>
                            <Card className="border-0 shadow-sm rounded-3">
                                <Card.Header className="py-3" style={{ background: '#21ACCD', borderTopLeftRadius: '12px', borderTopRightRadius: '12px' }}>
                                    <h5 className="mb-0 text-white">
                                        <i className="ri-user-add-line me-2"></i>
                                        Formulaire d'ajout d'employé
                                    </h5>
                                </Card.Header>
                                <Card.Body className="p-4">
                                    <Form onSubmit={handleSubmit}>
                                        {/* SECTION 1 : Informations personnelles */}
                                        <h6 className="mb-3 fw-semibold" style={{ color: '#21ACCD' }}>
                                            <i className="ri-user-line me-2"></i>
                                            Informations personnelles
                                        </h6>
                                        <Row className="g-3 mb-4">
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Nom <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="nom"
                                                        value={employe.nom}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Prénom <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="prenom"
                                                        value={employe.prenom}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="email"
                                                        value={employe.email}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Téléphone</Form.Label>
                                                    <Form.Control
                                                        type="tel"
                                                        name="telephone"
                                                        value={employe.telephone}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group>
                                                    <Form.Label>Adresse</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={2}
                                                        name="adresse"
                                                        value={employe.adresse}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Date de naissance</Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="date_naissance"
                                                        value={employe.date_naissance}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Lieu de naissance</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="lieu_naissance"
                                                        value={employe.lieu_naissance}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group>
                                                    <Form.Label>Nationalité</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="nationalite"
                                                        value={employe.nationalite}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group>
                                                    <Form.Label>Sexe</Form.Label>
                                                    <Form.Select
                                                        name="sexe"
                                                        value={employe.sexe}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="M">Masculin</option>
                                                        <option value="F">Féminin</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group>
                                                    <Form.Label>Situation matrimoniale</Form.Label>
                                                    <Form.Select
                                                        name="situation_matrimoniale"
                                                        value={employe.situation_matrimoniale}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="Célibataire">Célibataire</option>
                                                        <option value="Marié(e)">Marié(e)</option>
                                                        <option value="Divorcé(e)">Divorcé(e)</option>
                                                        <option value="Veuf(ve)">Veuf(ve)</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={3}>
                                                <Form.Group>
                                                    <Form.Label>Nombre d'enfants</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="nombre_enfants"
                                                        value={employe.nombre_enfants}
                                                        onChange={handleChange}
                                                        min="0"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {/* SECTION 2 : Informations professionnelles */}
                                        <h6 className="mb-3 fw-semibold" style={{ color: '#21ACCD' }}>
                                            <i className="ri-briefcase-line me-2"></i>
                                            Informations professionnelles
                                        </h6>
                                        <Row className="g-3 mb-4">
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Poste</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="poste"
                                                        value={employe.poste}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Département</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="departement"
                                                        value={employe.departement}
                                                        onChange={handleChange}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Date d'embauche <span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="date_embauche"
                                                        value={employe.date_embauche}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Type de contrat</Form.Label>
                                                    <Form.Select
                                                        name="type_contrat"
                                                        value={employe.type_contrat}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="CDI">CDI</option>
                                                        <option value="CDD">CDD</option>
                                                        <option value="Stage">Stage</option>
                                                        <option value="Alternance">Alternance</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Salaire de base (FCFA)</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="salaire_base"
                                                        value={employe.salaire_base}
                                                        onChange={handleChange}
                                                        min="0"
                                                        step="1000"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Statut</Form.Label>
                                                    <Form.Select
                                                        name="statut"
                                                        value={employe.statut}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="actif">Actif</option>
                                                        <option value="inactif">Inactif</option>
                                                        <option value="suspendu">Suspendu</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {/* SECTION 3 : Documents */}
                                        <h6 className="mb-3 fw-semibold" style={{ color: '#21ACCD' }}>
                                            <i className="ri-file-text-line me-2"></i>
                                            Documents
                                        </h6>
                                        <Row className="g-3 mb-4">
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>Photo de profil</Form.Label>
                                                    <Form.Control
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(e) => handleFileChange(e, 'photo')}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Format JPG, PNG (max 5 Mo)
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group>
                                                    <Form.Label>CV</Form.Label>
                                                    <Form.Control
                                                        type="file"
                                                        accept=".pdf,.doc,.docx"
                                                        onChange={(e) => handleFileChange(e, 'cv')}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Format PDF, DOC, DOCX (max 5 Mo)
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <hr className="my-4" />
                                        <div className="d-flex justify-content-end gap-3">
                                            <Button 
                                                variant="outline-secondary" 
                                                onClick={() => navigate('/rh/employes')}
                                                className="rounded-pill px-4"
                                            >
                                                Annuler
                                            </Button>
                                            <Button 
                                                type="submit" 
                                                variant="primary"
                                                disabled={saving}
                                                className="rounded-pill px-5"
                                                style={{ background: '#21ACCD', border: 'none' }}
                                            >
                                                {saving ? (
                                                    <>
                                                        <Spinner size="sm" className="me-2" />
                                                        Enregistrement...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="ri-save-line me-2"></i>
                                                        Enregistrer
                                                    </>
                                                )}
                                            </Button>
                                        </div>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <Footer />
            </div>

            <style>{`
                .rounded-3 { border-radius: 12px !important; }
                .rounded-pill { border-radius: 50px !important; }
                .fs-20 { font-size: 1.25rem; }
                @keyframes slideInRight {
                    from { opacity: 0; transform: translateX(100%); }
                    to { opacity: 1; transform: translateX(0); }
                }
                @keyframes shrink {
                    from { width: 100%; }
                    to { width: 0%; }
                }
                .toast-notification-fixed { animation: slideInRight 0.3s ease-out; }
            `}</style>
        </>
    );
}